import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function useAdminChangelogEvents(client, query, paging) {
    const fetcher = useCallback(([_action, query, paging]) => fetchChangelogEvents(client, query, paging), [client]);
    const { data, error } = useSWR(query ? CACHE_KEYS.adminChangelogEvents(query, paging) : null, fetcher);
    // useDebugLogChangedValues('useAdminChangelogEvents changed values', { data, error });
    return { connection: data, connectionError: error };
}
async function fetchChangelogEvents(client, query, paging) {
    const result = await client.getChangelogEvents(query, paging);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminChangelogEvents.js.map